import { TableBuildingListCell } from '../../Table'
import { toChatTableRowBuildingCellData } from '../ChatTableRow'

function ChatTableRowBuildings({ scrollRef, value, ...restProps }) {
  const preparedValue = value?.map(toChatTableRowBuildingCellData)

  return (
    <TableBuildingListCell
      {...restProps}
      scrollRef={scrollRef}
      value={preparedValue}
    />
  )
}

export default ChatTableRowBuildings
